// ערכת מותג — snapshot שנשמר בכל brand_version.
import { z } from 'zod';

const hex = z.string().regex(/^#[0-9a-fA-F]{6}$/);

export const BrandKit = z.object({
  logos: z.array(z.object({
    assetId: z.string(),
    variant: z.enum(['primary', 'light', 'dark', 'icon', 'other']),
  })).default([]),
  colors: z.array(z.object({
    hex,
    role: z.enum(['primary', 'secondary', 'accent', 'text', 'background', 'cta', 'other']),
    name: z.string().max(60).optional(),
  })).default([]),
  fonts: z.array(z.object({
    family: z.string().max(100),
    weights: z.array(z.number().int()).default([400]),
    assetId: z.string().nullable().default(null), // קובץ פונט; null = שם בלבד
    embedLicensed: z.boolean().default(false),
    role: z.enum(['headline', 'body', 'cta', 'other']).default('other'),
  })).default([]),
  logoClearSpacePx: z.number().min(0).max(500).nullable().default(null),
  logoMinWidthPx: z.number().min(0).max(2000).nullable().default(null),
  minFontSizePx: z.number().min(4).max(100).default(10),
  imageStyle: z.string().max(2000).default(''),
  animationStyle: z.string().max(2000).default(''),
  contentGuidelines: z.string().max(5000).default(''),
  guideText: z.string().max(50000).default(''),
  approvedExampleAssetIds: z.array(z.string()).default([]),
});
export type BrandKit = z.infer<typeof BrandKit>;

export const CampaignOverrides = z.object({
  colors: BrandKit.shape.colors.optional(),
  fonts: BrandKit.shape.fonts.optional(),
}).default({});
export type CampaignOverrides = z.infer<typeof CampaignOverrides>;

/** ערכה אפקטיבית לקמפיין + רשימת חריגות להצגה */
export function effectiveKit(kit: BrandKit, ov: CampaignOverrides | null | undefined): { kit: BrandKit; overridden: string[] } {
  const overridden: string[] = [];
  const out = structuredClone(kit);
  if (ov?.colors) { out.colors = ov.colors; overridden.push('colors'); }
  if (ov?.fonts) { out.fonts = ov.fonts; overridden.push('fonts'); }
  return { kit: out, overridden };
}

/** הבדלים בין שתי גרסאות מותג — לתצוגת diff לפני עדכון קמפיין */
export function diffKits(a: BrandKit, b: BrandKit): { field: string; before: unknown; after: unknown }[] {
  const out: { field: string; before: unknown; after: unknown }[] = [];
  for (const k of Object.keys(BrandKit.shape) as (keyof BrandKit)[]) {
    if (JSON.stringify(a[k]) !== JSON.stringify(b[k])) out.push({ field: k, before: a[k], after: b[k] });
  }
  return out;
}
